<template>
    <div class="login-page">
        <div class="login-box">
            <div class="login-box-left">
                <img src="../assets/image/bg-left@2x.png" alt="">
            </div>
            <div class="login-box-right">
                <img class="bg bg-a" src="../assets/image/bg-a@2x.png" />
                <img class="bg bg-b" src="../assets/image/bg-b@2x.png" />
                <img class="bg bg-c" src="../assets/image/bg-c@2x.png" />
                <img class="bg bg-d" src="../assets/image/bg-d@2x.png" />
                <a-form :form="form" class="login-form" @submit="handleSubmit">
                    <div class="login-logo"><img src="../assets/image/logo@2x.png" alt=""></div>
                    <div class="sys-name">阿派朗创造力乐园后台管理系统</div>
                    <div class="page-name">登录</div>
                    <div class="welcome">欢迎使用阿派朗创造力乐园后台管理系统</div>
                    <a-form-item>
                        <a-input
                            v-decorator="[
                        'account',
                        { rules: [{ required: true, message: '请输入账号名！' }] }
                    ]"
                            placeholder="账号"
                            size="large"
                        >
                            <a-icon slot="prefix" type="user" style="color: #FFBF00;"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-input
                            v-decorator="[
                        'password',
                        { rules: [{ required: true, message: '请输入密码！' }] }
                    ]"
                            type="password"
                            placeholder="密码"
                            size="large"
                        >
                            <a-icon slot="prefix" type="lock" style="color: #FFBF00;"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item>
                        <a-button class="sub-btn" html-type="submit" size="large" :loading="loading" block>登录</a-button>
                    </a-form-item>
                    <div class="text-notes">
                        <a-icon type="info-circle" theme="filled" />
                        忘记密码请联系管理员
                    </div>
                </a-form>
            </div>
        </div>
    </div>
</template>

<script>
import UserInfoTool from '../plugins/user-info-tool.js';
    export default {
        data() {
            return {
                loading: false
            };
        },
        methods: {
            handleSubmit(e) {
                e.preventDefault();
                this.loading = true;
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.$api.user.login({
                            body: values
                        })
                        .then( res =>{
                            sessionStorage.setItem("currentShopName", '');
                            sessionStorage.setItem("currentShopId", res.shopIdList[0]);
                            UserInfoTool.setUser(res);
                            this.$message.success('登录成功');
                            this.$router.push({ name: "homePage" });
                            this.loading = false;
                            if (values.password === '3e7w8dps') {
                                sessionStorage.setItem('setNew', '1');
                            }
                        })
                        .catch( err => {
                            this.loading = false;
                        })
                    }
                });
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        }
    };
</script>

<style rel="stylesheet/scss" lang="scss">
.login-page {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    height: 100vh;
    .login-box {
        display: flex;
        justify-content: space-between;
        width: 1440px;
        background: #ffffff;
        overflow: hidden;
        &-left {
            width: 696px;
            height: 718px;
            background: #F5F3ED;
            border-radius: 18px;
            margin: 16px 0px 16px 16px;
        }
        &-right {
            display: flex;
            flex: 1;
            justify-content: center;
            position: relative;
            overflow: hidden;
            .bg {
                position: absolute;
                &-a {
                    width: 234.59px;
                    top: 67px;
                    left: -30px;
                }
                &-b {
                    width: 66.2px;
                    top: 91px;
                    left: 596px;
                }
                &-c {
                    width: 149.8px;
                    top: 609px;
                    left: -3px;
                }
                &-d {
                    width: 317.07px;
                    top: 485px;
                    left: 450px;
                }
            }
            .login-form {
                width: 368px;
                .text-notes {
                    font-weight: 400;
                    font-size: 14px;
                    color: rgba(0,0,0,0.45);
                    line-height: 22px;
                }
                .sys-name {
                    font-size: 10px;
                    color: rgba(0,0,0,0.45);
                    letter-spacing: 13.33px;
                    text-align: center;
                    line-height: 18px;
                    margin-bottom: 72px;
                }
                .page-name {
                    font-weight: 500;
                    font-size: 22px;
                    color: rgba(0,0,0,0.85);
                    line-height: 30px;
                    margin-bottom: 8px;
                }
                .welcome {
                    font-size: 14px;
                    color: rgba(0,0,0,0.45);
                    line-height: 22px;
                    margin-bottom: 24px;
                }
                .login-logo {
                    text-align: center;
                    margin:48px 0 16px 0;
                    img {
                        width: 200px;
                        height: 72px;
                    }
                }
                .ant-input {
                    border-radius: 2px;
                    border: 1px solid #D9D9D9;
                    padding-left: 35px;
                }
                .sub-btn {
                    font-weight: 500;
                    font-size: 16px;
                    color: #6B442A;
                    line-height: 24px;
                    background: #FFBF00;
                    border-radius: 2px;
                }
            }
        }
    }
}
@media screen and (max-width: 1024px) {
    .login-box-left {
        display: none;
    }
}
</style>
